import { Link } from "react-router-dom";
import Icon from "../components/Icon";
import CountUp from "../components/CountUp";
import { ABOUT_BLOCKS, STATS } from "../content/site";
import useDocumentTitle from "../lib/useDocumentTitle";
import s from "./About.module.css";

export default function About() {
  useDocumentTitle("O nás");

  return (
    <>
      <section className={s.hero}>
        <img src="/hero.jpg" alt="" aria-hidden="true" className={s.heroImg} />
        <div className="container">
          <p className="eyebrow">O nás</p>
          <h1 className={s.title}>Elektromobil z EU <span>bez starostí</span></h1>
          <p className={s.lead}>
            Specializujeme se na individuální dovoz elektromobilů ze zahraničí. Vybíráme vozy
            {" "}<strong>staré 1–6 let</strong> ze všech cenových kategorií, před předáním je
            {" "}<strong>kompletně vyčistíme a vydezinfikujeme</strong> a zajistíme
            {" "}<strong>dovozovou STK i EL značky</strong>. U většiny vozů je možné uplatnit
            {" "}<strong>odpočet DPH</strong>.
          </p>

          <dl className={`glow ${s.stats}`}>
            {STATS.map((st) => (
              <div key={st.label}>
                <Icon name={st.icon} size={26} className={s.statIcon} />
                <dd className="num"><CountUp value={st.value} /></dd>
                <dt>{st.label}</dt>
              </div>
            ))}
          </dl>
        </div>
      </section>

      <section className="section">
        <div className={`container ${s.blocks}`}>
          {ABOUT_BLOCKS.map((b) => (
            <article key={b.title} className={`glow glow-hover ${s.block}`}>
              {b.photo
                ? <img src={b.photo} alt="Josef Černý, VoltNaPřání" className={s.photo} width="56" height="56" />
                : <span className={s.iconPlate}><Icon name={b.icon} size={24} /></span>}
              <h2>{b.title}</h2>
              <p>{b.text}</p>
            </article>
          ))}
        </div>
      </section>

      <section className={s.band}>
        <div className={`container ${s.bandInner}`}>
          <div>
            <h2 className="h2">Pojďme najít váš elektromobil</h2>
            <p className="muted" style={{ marginTop: 8 }}>Nezávazná poptávka, odpověď do 24 hodin.</p>
          </div>
          <div className={s.bandCtas}>
            <Link to="/dovoz" className="btn btn-primary btn-lg">Poptat dovoz <Icon name="arrow-right" size={18} /></Link>
            <Link to="/kontakt" className="btn btn-ghost btn-lg">Kontakt</Link>
          </div>
        </div>
      </section>
    </>
  );
}
